<template><svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" viewBox="0 0 32 32">
  <path d="M8.06 17.17l11.81 12.34a1.53 1.53 0 0 0 2.24 0 1.7 1.7 0 0 0 0-2.35L11.44 16 22.11 4.84a1.7 1.7 0 0 0 0-2.35A1.53 1.53 0 0 0 21 2a1.59 1.59 0 0 0-1.14.53L8.06 14.87A1.51 1.51 0 0 0 7.59 16a1.64 1.64 0 0 0 .47 1.17z" fill="currentColor" />
</svg>
</template>